import React, {RefObject} from 'react';
import {MapComponent} from "./MapComponent";
import {defineAppComponent} from "./store/Accessor";
import MainMenu from "./components/MainMenu";
import LeftToolbox from "./components/LeftToolbox";
import {ExclamationTriangleIcon, ProgressBar, ThemeProvider} from "@ice/components";
import {getAppState} from "./store/AppState";
import {$t} from "./lang/LangUtil";
import {PolygonProvider} from "./util/PolygonProvider";


interface PolygonDownloadStatusProps {
}


interface PolygonDownloadStatusState {
    pct: number;
}


class PolygonDownloadStatus extends React.Component<PolygonDownloadStatusProps, PolygonDownloadStatusState> {
    constructor(props: PolygonDownloadStatusProps) {
        super(props);
        this.state = {
            pct: NaN
        };
    }

    updatePercent = (pct: number) => {
        this.setState({pct: pct});
    }

    render = () => {
        if (this.state.pct < 0.99999) {
            let notStarted = this.state.pct < 0.0001;
            return (
                <div className={"polygondownloadstatus"}>
                    <ProgressBar
                        value={notStarted ? null : this.state.pct}
                        intent={notStarted ? null : "info"}
                        style={{width: "100%"}}
                        title={$t("downloadingpoly")}
                    />
                </div>
            );
        }

        return null;
    }
}


interface AppState {
    dialog: any;
    hasPolygonsError: boolean;
}



interface AppProps {
}


interface AppState {
    dialog: any;
    hasPolygonsError: boolean;
}


export default class App extends React.Component<AppProps, AppState> {

    private leftToolboxRef: RefObject<LeftToolbox> = React.createRef<LeftToolbox>();

    private polygonDownloaderStatusRef: RefObject<PolygonDownloadStatus> = React.createRef<PolygonDownloadStatus>();

    constructor(props: AppState) {
        super(props);
        defineAppComponent(this);
        this.state = {
            dialog: null,
            hasPolygonsError: false
        };
    }

    refresh = () => {
        this.forceUpdate();
        this.refreshToolbox();
    }

    refreshToolbox = () => {
        if (this.leftToolboxRef.current) {
            this.leftToolboxRef.current.refresh();
        }
    }

    showDialog = (dlg) => {
        this.setState({dialog: dlg});
    }

    hideDialog = () => {
        this.showDialog(null);
    }

    updatePolygonProviderStatus = (): void => {
        if (this.polygonDownloaderStatusRef.current) {
            const newPct = Math.round((PolygonProvider.getInstance().getPercentDone()) * 100) / 100;
            this.polygonDownloaderStatusRef.current.updatePercent(newPct);
        }
    }

    private renderPolygonError = (): JSX.Element => {
        if (this.state.hasPolygonsError) {
            return (
                <div className={"polygonerrorstatus"}>
                    <ExclamationTriangleIcon intent={"warning"} title={$t("polyerr")} />
                </div>
            );
        }
        return null;
    }

    render(): React.ReactNode {
        let appState = getAppState();

        return (
            <div className={"fullscreen"}>
                <ThemeProvider name={appState.getTheme()}>
                    <MapComponent />
                    <MainMenu />
                    <LeftToolbox ref={this.leftToolboxRef} />
                    <PolygonDownloadStatus ref={this.polygonDownloaderStatusRef} />
                    { this.renderPolygonError() }
                    { this.state.dialog }
                </ThemeProvider>
            </div>
        );
    }

}

